<template>
  <div class="filter-form">
    <a-form :form="formRQ" layout="vertical">
      <a-row :gutter="[6, 6]" type="flex" align="bottom" justify="start">
        <a-col
          v-for="{ label, placeholder, name, type, width, keyMatchCount } in filterList"
          v-bind="width ? width : { xl: 4, md: 5 }"
          :sm="12"
          :key="name"
        >
          <a-form-item :label="label" v-if="type !== FILTER_TYPE_BUTTON">
            <a-range-picker
              v-if="type === FILTER_TYPE_DATE_RANGE"
              :placeholder="placeholder"
              :format="DATE_FORMAT_V2"
              :style="{ width: '100%' }"
              v-decorator="[
                name,
                {
                  initialValue: handleImportDateInitValue(name),
                },
              ]"
            >
              <template #suffixIcon>
                <img :src="Calendar" alt="Calendar" />
              </template>
            </a-range-picker>

            <a-input
              v-if="type === FILTER_TYPE_INPUT"
              allowClear
              :placeholder="placeholder"
              v-decorator="[
                name,
                {
                  initialValue: dataFilterDefault[name],
                },
              ]"
              @pressEnter="handleFilter"
            />
            <a-date-picker
              v-if="type === FILTER_TYPE_DATE"
              :placeholder="placeholder"
              :format="DATE_FORMAT_V2"
              :style="{ width: '100%' }"
              v-decorator="[
                name,
                {
                  initialValue: dataFilterDefault[name],
                },
              ]"
            />
            <a-select
              v-else-if="type === FILTER_TYPE_AUTO_COMPLETE"
              allowClear
              mode="multiple"
              :class="dynamicClass"
              :placeholder="placeholder"
              :style="{ width: '100%' }"
              :default-active-first-option="false"
              :notFoundContent="fetching ? undefined : null"
              :filter-option="false"
              :maxTagCount="1"
              :maxTagTextLength="10"
              :dropdownMatchSelectWidth="false"
              @search="(value) => onSearch(value, name)"
              @change="(value) => handleChangeSelect(name, value)"
              v-decorator="[
                name,
                {
                  initialValue: dataFilterDefault[name],
                },
              ]"
            >
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <template v-if="name === FILTER_KEY_EMPLOYEE">
                <a-select-option v-for="{ value, label, key } in employeeList" :key="key" :value="value">
                  {{ label }}
                </a-select-option>
              </template>
            </a-select>
            <a-select
              v-else-if="type === FILTER_TYPE_MULTIPLE_SELECT || type === FILTER_TYPE_SELECT"
              :allowClear="name === FILTER_KEY_TIME_SHEET ? false : true"
              :mode="type === FILTER_TYPE_MULTIPLE_SELECT ? 'multiple' : ''"
              showSearch
              :placeholder="placeholder"
              :style="{ width: '100%' }"
              :showArrow="true"
              :not-found-content="fetching ? undefined : null"
              :filter-option="name !== 'projectIds' ? (keyMatchCount ? filterOptionKeyMatch : filterOption) : false"
              @search="onSearchProject"
              @popupScroll="popupScroll"
              :maxTagCount="1"
              :maxTagTextLength="10"
              v-decorator="[
                name,
                {
                  initialValue: dataFilterDefault[name],
                },
              ]"
              @change="(value) => handleChangeSelect(name, value)"
            >
              <template v-if="name === FILTER_KEY_TIME_SHEET">
                <a-select-option
                  v-for="item in payrollPeriodList"
                  :key="item.timesheet_id"
                  :value="item.timesheet_id"
                  >{{
                    (item.from_date ? moment(item.from_date).format(DATE_FORMAT_V2) : "") +
                    " - " +
                    moment(item.to_date, DATE_FORMAT_SHORT).format(DATE_FORMAT_V2)
                  }}</a-select-option
                >
              </template>
              <template v-if="name === FILTER_KEY_DIVISION">
                <a-select-option
                  v-for="item in divisionList"
                  :key="item.department_code"
                  :value="item.department_code"
                  >{{ item.name }}</a-select-option
                >
              </template>
              <template v-if="name === FILTER_KEY_DEPARTMENT">
                <a-select-option
                  v-for="item in departmentFilterList"
                  :key="item.department_code"
                  :value="item.department_code"
                  >{{ item.name }}</a-select-option
                >
              </template>
              <template v-if="name === FILTER_KEY_ROLE">
                <a-select-option v-for="role in roleList" :key="role.code" :value="role.code">{{
                  role.name
                }}</a-select-option>
              </template>
              <template v-if="name === FILTER_KEY_WORK_SCHEDULE_CODE">
                <a-select-option
                  v-for="{ work_schedule_code } in workRuleWorkScheduleConfigList"
                  :key="work_schedule_code"
                  :value="work_schedule_code"
                  >{{ work_schedule_code }}</a-select-option
                >
              </template>
              <template v-if="name === FILTER_KEY_WORK_SCHEDULE_TYPE">
                <a-select-option v-for="{ code, nameVi } in workScheduleTypeList" :key="code" :value="code">{{
                  nameVi
                }}</a-select-option>
              </template>
              <template v-if="name === FILTER_KEY_PROJECT">
                <a-select-option
                  v-for="{ project_id, project_name } in projectFilterList"
                  :key="project_id"
                  :value="project_id"
                >
                  {{ project_name }}
                </a-select-option>
              </template>
              <template v-if="name === FILTER_KEY_OBJECT">
                <a-select-option v-for="{ key, title, value } in OBJECT_TYPES" :key="key" :value="value">
                  {{ title }}
                </a-select-option>
              </template>
            </a-select>
            <a-checkbox style="margin-top: 7px" v-else-if="type === FILTER_TYPE_CHECKBOX" :checked="filters[name]"
              >{{ placeholder }}
            </a-checkbox>
          </a-form-item>
          <a-form-item v-if="type === FILTER_TYPE_BUTTON">
            <a-row type="flex" :gutter="[6, 0]">
              <a-col>
                <Button type="primary" @click="handleFilter">{{ label }}</Button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-col>
        <!-- <a-col :xl="2" :md="6" class="filter-action">
          <a-form-item>
            <a-row type="flex" :gutter="[6, 0]">
              <a-col>
                <Button type="primary" @click="handleFilter">Search</Button>
              </a-col>
              <a-col>
                <Button type="reset" @click="handleResetFilter">Reload</Button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-col> -->
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { Button } from "@/components";
import { Calendar } from "@/assets";
import {
  filtersJson,
  formatDateToString,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  EXCEED_TYPE,
  getInfoStaff,
  filterOption,
  filterOptionKeyMatch,
  FILTER_TYPE_BUTTON,
  FILTER_TYPE_DATE_RANGE,
  FILTER_TYPE_INPUT,
  FILTER_TYPE_DATE,
  FILTER_TYPE_AUTO_COMPLETE,
  FILTER_KEY_EMPLOYEE,
  FILTER_TYPE_MULTIPLE_SELECT,
  FILTER_TYPE_SELECT,
  FILTER_KEY_TIME_SHEET,
  FILTER_KEY_DIVISION,
  FILTER_KEY_DEPARTMENT,
  FILTER_KEY_ROLE,
  FILTER_KEY_PROJECT,
  FILTER_KEY_WORK_SCHEDULE_CODE,
  FILTER_KEY_WORK_SCHEDULE_TYPE,
  FILTER_TYPE_CHECKBOX,
  FILTER_KEY_OBJECT,
  OBJECT_TYPES,
} from "@/utils";
import moment from "moment";
import { mapState } from "vuex";
import {
  GET_DEPARTMENT_BY_DIVISION_LIST,
  GET_EMPLOYEE_BY_PROJECT_LIST,
  GET_PROJECT_REDIS_LIST_BY_PAGINATION,
  SET_PAGE_SELECT,
} from "@/store/mutation-types";

export default {
  name: "FilterLayout",
  components: {
    Button,
  },
  props: {
    currentPage: {
      type: String,
    },
    currentTab: {
      type: String,
    },
    requestId: {
      type: Number,
    },
    dynamicClass: String,
    payloadRequest: {},
    dataFilterDefault: {
      type: Object,
      default: () => {
        return {};
      },
    },
    filterList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      formRQ: this.$form.createForm(this, {
        name: "filterCommon",
        onValuesChange: this.onValuesChange,
      }),
      filterConfig: {},
      fetching: false,
      DATE_FORMAT_SHORT,
      DATE_FORMAT_V2,
      departmentFilterList: [],
      EXCEED_TYPE,
      timeout: null,
      Calendar,
      projectFilterList: [],
      disabledScroll: false,
      FILTER_TYPE_BUTTON,
      FILTER_TYPE_DATE_RANGE,
      FILTER_TYPE_INPUT,
      FILTER_TYPE_DATE,
      FILTER_TYPE_AUTO_COMPLETE,
      FILTER_TYPE_MULTIPLE_SELECT,
      FILTER_TYPE_SELECT,
      FILTER_TYPE_CHECKBOX,
      FILTER_KEY_EMPLOYEE,
      FILTER_KEY_TIME_SHEET,
      FILTER_KEY_DIVISION,
      FILTER_KEY_DEPARTMENT,
      FILTER_KEY_ROLE,
      FILTER_KEY_PROJECT,
      FILTER_KEY_WORK_SCHEDULE_CODE,
      FILTER_KEY_WORK_SCHEDULE_TYPE,
      FILTER_KEY_OBJECT,
      OBJECT_TYPES,
    };
  },

  computed: {
    ...mapState({
      payrollPeriodList: (state) => state.application.payrollPeiodList,
      divisionList: (state) => state.filters.divisionList,
      departmentList: (state) => state.filters.departmentList,
      departmentByDivisionList: (state) => state.filters.departmentByDivisionList,
      roleList: (state) => state.filters.roleList,
      employeeList: (state) => state.filters.employeeList,
      workRuleWorkScheduleConfigList: (state) => state.filters.workRuleWorkScheduleConfigList,
      workScheduleTypeList: (state) => state.filters.workScheduleTypeList,
      projectRedisList: (state) => state.filters.projectRedisList,
      projectRedisListByPagination: (state) => state.filters.projectRedisListByPagination,
    }),
  },

  watch: {
    currentTab: function () {
      this.getFiltersJson();
    },
    filterConfig() {
      this.getFilterSelectData();
    },
    filterList() {
      this.getFilterSelectData();
    },
    formRQ() {},
  },
  methods: {
    moment,
    formatDateToString,
    getInfoStaff,
    filterOption,
    filterOptionKeyMatch,
    ////Get config control
    // onValuesChange() {
    //   this.handleFilter();
    // },
    handleFilter() {
      this.formRQ.validateFields((err, values) => {
        if (err) return;
        const { applyDate, expireDate, onboardDate, ...payload } = values;
        if (applyDate?.length > 0) {
          payload.applyFromDate = moment(applyDate?.[0]).format(DATE_FORMAT_V2);
          payload.applyToDate = moment(applyDate?.[1]).format(DATE_FORMAT_V2);
        } else {
          delete payload?.applyFromDate;
          delete payload?.applyToDate;
        }
        if (expireDate?.length > 0) {
          payload.expireFromDate = moment(expireDate?.[0]).format(DATE_FORMAT_V2);
          payload.expireToDate = moment(expireDate?.[1]).format(DATE_FORMAT_V2);
        } else {
          delete payload?.expireFromDate;
          delete payload?.expireToDate;
        }
        if (onboardDate?.length > 0) {
          payload.onboardFromDate = moment(onboardDate?.[0]).format(DATE_FORMAT_V2);
          payload.onboardToDate = moment(onboardDate?.[1]).format(DATE_FORMAT_V2);
        } else {
          delete payload?.onboardFromDate;
          delete payload?.onboardToDate;
        }
        this.$emit("handleFilter", payload);
      });
    },
    handleResetFilter() {
      this.formRQ.resetFields();
      this.$emit("handleResetFilter");
    },
    popupScroll(e) {
      if (!this.disabledScroll) {
        const { scrollTop, scrollHeight, offsetHeight } = e.target;
        if (scrollTop + offsetHeight === scrollHeight) {
          this.$store.commit(`filters/${GET_PROJECT_REDIS_LIST_BY_PAGINATION}`);
          this.projectFilterList = this.projectRedisListByPagination;
        }
      }
    },
    onSearchProject(value, timeout = 1000) {
      if (!value || !value.trim() || value.trim().length <= 2) {
        if (!value) {
          this.$store.commit(`filters/${SET_PAGE_SELECT}`, 1);
          this.$store.commit(`filters/${GET_EMPLOYEE_BY_PROJECT_LIST}`, []);
          this.$store.commit(`filters/${GET_PROJECT_REDIS_LIST_BY_PAGINATION}`);
          this.projectFilterList = this.projectRedisListByPagination;
          this.disabledScroll = false;
        }
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.fetching = true;
      this.timeout = setTimeout(async () => {
        try {
          const projectFilter = this.projectRedisList.filter(
            (project) => project.project_name.toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
          this.projectFilterList = projectFilter;
        } finally {
          this.disabledScroll = true;
          this.fetching = false;
        }
      }, timeout);
    },
    getFiltersJson() {
      const currentPage = this.currentPage;
      const currentTab = this.currentTab;
      let findObj = filtersJson[currentPage];
      if (currentTab) findObj = findObj[currentTab];
      if (findObj) {
        this.filterConfig = findObj;
      } else this.filterConfig = {};
    },
    handleChangeSelect(name, value) {
      this.formRQ.setFieldsValue({ [name]: value });
      if (name === FILTER_KEY_DIVISION) {
        if (!value || value?.length <= 0) {
          this.departmentFilterList = this.departmentList;
        } else {
          this.$store.commit("filters/GET_DEPARTMENT_BY_DIVISION_LIST", value);
          this.departmentFilterList = this.departmentByDivisionList;
          const departmentCodeFilterList = this.departmentFilterList?.map((department) => department.department_code);
          const departments = this.formRQ.getFieldValue("departments");
          if (departments && departments?.length > 0) {
            const newDepartmentsFilter = departments.filter((departmentCode) =>
              departmentCodeFilterList.includes(departmentCode)
            );
            this.formRQ.setFieldsValue({ departments: newDepartmentsFilter });
          }
        }
      }
    },
    handleImportDateInitValue(name) {
      if (this.dataFilterDefault.fromDate && this.dataFilterDefault.toDate)
        return [
          moment(this.dataFilterDefault.fromDate, "DD/MM/YYYY"),
          moment(this.dataFilterDefault.toDate, "DD/MM/YYYY"),
        ];
      else {
        return this.dataFilterDefault[name];
      }
    },
    async getFilterSelectData() {
      const { filterList } = this;
      if (filterList) {
        filterList.map((item) => {
          switch (item.name) {
            case FILTER_KEY_TIME_SHEET: {
              this.$store.dispatch("application/getListPayrollPeriodList").then(() => {
                const { timesheetId } = this.dataFilterDefault;
                if (!timesheetId) {
                  this.formRQ.setFieldsValue({
                    timesheetId: this.payrollPeriodList.find((timesheet) => timesheet.is_current_timesheet)
                      ?.timesheet_id,
                  });
                  this.handleFilter();
                }
              });
              break;
            }
            case FILTER_KEY_DIVISION:
              this.$store.dispatch("filters/getDivisionList").then(() => {
                const { divisions } = this.dataFilterDefault;
                if (divisions) {
                  this.$store.commit(`filters/${GET_DEPARTMENT_BY_DIVISION_LIST}`, divisions);
                  this.departmentFilterList = this.departmentByDivisionList;
                } else {
                  this.departmentFilterList = this.departmentList;
                }
              });
              break;
            case FILTER_KEY_ROLE:
              this.$store.dispatch("filters/getRoleList");
              break;
            case FILTER_KEY_WORK_SCHEDULE_CODE:
              this.$store.dispatch("filters/getRuleWorkScheduleConfigList");
              break;
            case FILTER_KEY_WORK_SCHEDULE_TYPE:
              this.$store.dispatch("filters/getWorkScheduleTypeList");
              break;
            case FILTER_KEY_PROJECT:
              this.$store.dispatch("filters/getProjectRedisList", "").then(() => {
                this.projectFilterList = this.projectRedisListByPagination;
              });
              break;
            default:
              return;
          }
        });
      }
    },
    handleChangeDate(value, name) {
      this.formRQ.setFieldsValue({ [name]: value });
      this.handleFilter();
      // if (value.length === 0) {
      //   this.$emit("handleDeleteDateFilter", value);
      // }
    },
    onSearch(value, name) {
      if (!value || !value.trim() || value.length <= 2) {
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.fetching = true;
      this.timeout = setTimeout(() => {
        switch (name) {
          case FILTER_KEY_EMPLOYEE: {
            this.$store.dispatch("filters/getEmployeeList", value).finally(() => {
              this.fetching = false;
            });
          }
        }
      }, 1000);
    },
  },
  created() {
    // this.getFiltersJson();
    this.getFilterSelectData();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .ant-form {
  .ant-form-item {
    margin-bottom: 0;
    padding-bottom: 0;

    .ant-form-item-label {
      font-weight: 700;
      font-size: 13px;
      line-height: 24px;

      label {
        color: #4f656f;
      }
    }
  }
}
</style>
